import { Box, Button, Stack, Typography } from '@mui/material'
import React from 'react'
import WalletStar from './WalletStar'
import { fNumber } from '../../../utils/formatNumber'

const OrderPoints = ({
    order
}) => {

    if(!order?.earned_points) return null

    const points = fNumber(order?.earned_points, '0,0.0') ?? 0.00 

    if(!points || points <= 0) return null

    return ( 
        <Box sx={{
            border:theme => `1px solid ${theme.palette.primary.main}`,
            display:'inline-block',
            borderRadius:3,
            pl:1,
            py:0.5
        }}>
            <Stack direction='row' alignItems='center' justifyContent='center'>
                <WalletStar />
                <Box sx={{
                    px:2
                }}>
                    <Typography variant='body2' align='center' sx={{
                        'span':{
                            color: theme => theme.palette.primary.highlight,
                            fontWeight:600
                        }
                    }}>
                        Se abonaron <span>{`${points} celupuntos`}</span> con este pedido
                    </Typography>
                </Box>
            </Stack>
        </Box>
     );
}
 
export default OrderPoints;